export const lanList = [
  {
    english: "Afar",
    code: "aa",
  },
  {
    english: "Abkhazian",
    code: "ab",
  },
  {
    english: "Avestan",
    code: "ae",
  },
  {
    english: "Afrikaans",
    code: "af",
  },
  {
    english: "Akan",
    code: "ak",
  },
  {
    english: "Amharic",
    code: "am",
  },
  {
    english: "Aragonese",
    code: "an",
  },
  {
    english: "Arabic",
    code: "ar",
  },
  {
    english: "Assamese",
    code: "as",
  },
  {
    english: "Avaric",
    code: "av",
  },
  {
    english: "Aymara",
    code: "ay",
  },
  {
    english: "Azerbaijani",
    code: "az",
  },
  {
    english: "Bashkir",
    code: "ba",
  },
  {
    english: "Belarusian",
    code: "be",
  },
  {
    english: "Bulgarian",
    code: "bg",
  },
  {
    english: "Bihari languages",
    code: "bh",
  },
  {
    english: "Bislama",
    code: "bi",
  },
  {
    english: "Bambara",
    code: "bm",
  },
  {
    english: "Bengali",
    code: "bn",
  },
  {
    english: "Tibetan",
    code: "bo",
  },
  {
    english: "Breton",
    code: "br",
  },
  {
    english: "Bosnian",
    code: "bs",
  },
  {
    english: "Catalan; Valencian",
    code: "ca",
  },
  {
    english: "Chechen",
    code: "ce",
  },
  {
    english: "Chamorro",
    code: "ch",
  },
  {
    english: "Chinese",
    code: "cn",
  },
  {
    english: "Corsican",
    code: "co",
  },
  {
    english: "Cree",
    code: "cr",
  },
  {
    english: "Czech",
    code: "cs",
  },
  {
    english:
      "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
    code: "cu",
  },
  {
    english: "Chuvash",
    code: "cv",
  },
  {
    english: "Welsh",
    code: "cy",
  },
  {
    english: "Danish",
    code: "da",
  },
  {
    english: "German",
    code: "de",
  },
  {
    english: "Divehi; Dhivehi; Maldivian",
    code: "dv",
  },
  {
    english: "Dzongkha",
    code: "dz",
  },
  {
    english: "Ewe",
    code: "ee",
  },
  {
    english: "Greek, Modern (1453-)",
    code: "el",
  },
  {
    english: "English",
    code: "en",
  },
  {
    english: "Esperanto",
    code: "eo",
  },
  {
    english: "Spanish",
    code: "es",
  },
  {
    english: "Estonian",
    code: "et",
  },
  {
    english: "Basque",
    code: "eu",
  },
  {
    english: "Persian",
    code: "fa",
  },
  {
    english: "Fulah",
    code: "ff",
  },
  {
    english: "Finnish",
    code: "fi",
  },
  {
    english: "Fijian",
    code: "fj",
  },
  {
    english: "Faroese",
    code: "fo",
  },
  {
    english: "French",
    code: "fr",
  },
  {
    english: "Western Frisian",
    code: "fy",
  },
  {
    english: "Irish",
    code: "ga",
  },
  {
    english: "Gaelic; Scottish Gaelic",
    code: "gd",
  },
  {
    english: "Galician",
    code: "gl",
  },
  {
    english: "Guarani",
    code: "gn",
  },
  {
    english: "Gujarati",
    code: "gu",
  },
  {
    english: "Manx",
    code: "gv",
  },
  {
    english: "Hausa",
    code: "ha",
  },
  {
    english: "Hebrew",
    code: "he",
  },
  {
    english: "Hindi",
    code: "hi",
  },
  {
    english: "Hiri Motu",
    code: "ho",
  },
  {
    english: "Croatian",
    code: "hr",
  },
  {
    english: "Haitian; Haitian Creole",
    code: "ht",
  },
  {
    english: "Hungarian",
    code: "hu",
  },
  {
    english: "Armenian",
    code: "hy",
  },
  {
    english: "Herero",
    code: "hz",
  },
  {
    english: "Interlingua (International Auxiliary Language Association)",
    code: "ia",
  },
  {
    english: "Indonesian",
    code: "id",
  },
  {
    english: "Interlingue; Occidental",
    code: "ie",
  },
  {
    english: "Igbo",
    code: "ig",
  },
  {
    english: "Sichuan Yi; Nuosu",
    code: "ii",
  },
  {
    english: "Inupiaq",
    code: "ik",
  },
  {
    english: "Ido",
    code: "io",
  },
  {
    english: "Icelandic",
    code: "is",
  },
  {
    english: "Italian",
    code: "it",
  },
  {
    english: "Inuktitut",
    code: "iu",
  },
  {
    english: "Japanese",
    code: "ja",
  },
  {
    english: "Javanese",
    code: "jv",
  },
  {
    english: "Georgian",
    code: "ka",
  },
  {
    english: "Kongo",
    code: "kg",
  },
  {
    english: "Kikuyu; Gikuyu",
    code: "ki",
  },
  {
    english: "Kuanyama; Kwanyama",
    code: "kj",
  },
  {
    english: "Kazakh",
    code: "kk",
  },
  {
    english: "Kalaallisut; Greenlandic",
    code: "kl",
  },
  {
    english: "Central Khmer",
    code: "km",
  },
  {
    english: "Kannada",
    code: "kn",
  },
  {
    english: "Korean",
    code: "ko",
  },
  {
    english: "Kanuri",
    code: "kr",
  },
  {
    english: "Kashmiri",
    code: "ks",
  },
  {
    english: "Kurdish",
    code: "ku",
  },
  {
    english: "Komi",
    code: "kv",
  },
  {
    english: "Cornish",
    code: "kw",
  },
  {
    english: "Kirghiz; Kyrgyz",
    code: "ky",
  },
  {
    english: "Latin",
    code: "la",
  },
  {
    english: "Luxembourgish; Letzeburgesch",
    code: "lb",
  },
  {
    english: "Ganda",
    code: "lg",
  },
  {
    english: "Limburgan; Limburger; Limburgish",
    code: "li",
  },
  {
    english: "Lingala",
    code: "ln",
  },
  {
    english: "Lao",
    code: "lo",
  },
  {
    english: "Lithuanian",
    code: "lt",
  },
  {
    english: "Luba-Katanga",
    code: "lu",
  },
  {
    english: "Latvian",
    code: "lv",
  },
  {
    english: "Malagasy",
    code: "mg",
  },
  {
    english: "Marshallese",
    code: "mh",
  },
  {
    english: "Maori",
    code: "mi",
  },
  {
    english: "Macedonian",
    code: "mk",
  },
  {
    english: "Malayalam",
    code: "ml",
  },
  {
    english: "Mongolian",
    code: "mn",
  },
  {
    english: "Marathi",
    code: "mr",
  },
  {
    english: "Malay",
    code: "ms",
  },
  {
    english: "Maltese",
    code: "mt",
  },
  {
    english: "Burmese",
    code: "my",
  },
  {
    english: "Nauru",
    code: "na",
  },
  {
    english: "Bokmål, Norwegian; Norwegian Bokmål",
    code: "nb",
  },
  {
    english: "Ndebele, North; North Ndebele",
    code: "nd",
  },
  {
    english: "Nepali",
    code: "ne",
  },
  {
    english: "Ndonga",
    code: "ng",
  },
  {
    english: "Dutch; Flemish",
    code: "nl",
  },
  {
    english: "Norwegian Nynorsk; Nynorsk, Norwegian",
    code: "nn",
  },
  {
    english: "Norwegian",
    code: "no",
  },
  {
    english: "Ndebele, South; South Ndebele",
    code: "nr",
  },
  {
    english: "Navajo; Navaho",
    code: "nv",
  },
  {
    english: "Chichewa; Chewa; Nyanja",
    code: "ny",
  },
  {
    english: "Occitan (post 1500)",
    code: "oc",
  },
  {
    english: "Ojibwa",
    code: "oj",
  },
  {
    english: "Oromo",
    code: "om",
  },
  {
    english: "Oriya",
    code: "or",
  },
  {
    english: "Ossetian; Ossetic",
    code: "os",
  },
  {
    english: "Panjabi; Punjabi",
    code: "pa",
  },
  {
    english: "Pali",
    code: "pi",
  },
  {
    english: "Polish",
    code: "pl",
  },
  {
    english: "Pushto; Pashto",
    code: "ps",
  },
  {
    english: "Portuguese",
    code: "pt",
  },
  {
    english: "Quechua",
    code: "qu",
  },
  {
    english: "Romansh",
    code: "rm",
  },
  {
    english: "Rundi",
    code: "rn",
  },
  {
    english: "Romanian; Moldavian; Moldovan",
    code: "ro",
  },
  {
    english: "Russian",
    code: "ru",
  },
  {
    english: "Kinyarwanda",
    code: "rw",
  },
  {
    english: "Sanskrit",
    code: "sa",
  },
  {
    english: "Sardinian",
    code: "sc",
  },
  {
    english: "Sindhi",
    code: "sd",
  },
  {
    english: "Northern Sami",
    code: "se",
  },
  {
    english: "Sango",
    code: "sg",
  },
  {
    english: "Sinhala; Sinhalese",
    code: "si",
  },
  {
    english: "Slovak",
    code: "sk",
  },
  {
    english: "Slovenian",
    code: "sl",
  },
  {
    english: "Samoan",
    code: "sm",
  },
  {
    english: "Shona",
    code: "sn",
  },
  {
    english: "Somali",
    code: "so",
  },
  {
    english: "Albanian",
    code: "sq",
  },
  {
    english: "Serbian",
    code: "sr",
  },
  {
    english: "Swati",
    code: "ss",
  },
  {
    english: "Sotho, Southern",
    code: "st",
  },
  {
    english: "Sundanese",
    code: "su",
  },
  {
    english: "Swedish",
    code: "sv",
  },
  {
    english: "Swahili",
    code: "sw",
  },
  {
    english: "Tamil",
    code: "ta",
  },
  {
    english: "Telugu",
    code: "te",
  },
  {
    english: "Tajik",
    code: "tg",
  },
  {
    english: "Thai",
    code: "th",
  },
  {
    english: "Tigrinya",
    code: "ti",
  },
  {
    english: "Turkmen",
    code: "tk",
  },
  {
    english: "Tagalog",
    code: "tl",
  },
  {
    english: "Tswana",
    code: "tn",
  },
  {
    english: "Tonga (Tonga Islands)",
    code: "to",
  },
  {
    english: "Turkish",
    code: "tr",
  },
  {
    english: "Tsonga",
    code: "ts",
  },
  {
    english: "Tatar",
    code: "tt",
  },
  {
    english: "Twi",
    code: "tw",
  },
  {
    english: "Tahitian",
    code: "ty",
  },
  {
    english: "Uighur; Uyghur",
    code: "ug",
  },
  {
    english: "Ukrainian",
    code: "uk",
  },
  {
    english: "Urdu",
    code: "ur",
  },
  {
    english: "Uzbek",
    code: "uz",
  },
  {
    english: "Venda",
    code: "ve",
  },
  {
    english: "Vietnamese",
    code: "vi",
  },
  {
    english: "Volapük",
    code: "vo",
  },
  {
    english: "Walloon",
    code: "wa",
  },
  {
    english: "Wolof",
    code: "wo",
  },
  {
    english: "Xhosa",
    code: "xh",
  },
  {
    english: "Yiddish",
    code: "yi",
  },
  {
    english: "Yoruba",
    code: "yo",
  },
  {
    english: "Zhuang; Chuang",
    code: "za",
  },
  {
    english: "Chinese",
    code: "zh",
  },
  {
    english: "Zulu",
    code: "zu",
  },
];
